/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import oneschemaImporter from '@oneschema/importer';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
let _importer;
export const useImportStore = defineStore('importStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      handleError,
      imports: [],
      loading: false,
      error: null,
      sessionToken: undefined,
      templates: []
    };
  },
  actions: {
    async listTemplates() {
      const response = await axios({
        url: '/imports/templates'
      });
      this.templates = response.data;
    },
    async listImports() {
      try {
        this.loading = true;
        const response = await axios({
          url: '/imports'
        });
        const imports = response.data.map(item => ({
          ...item,
          showUndo: this.hasImportedItems(item),
          showSync: item.status === 'imported' && this.hasImportedClients(item),
          showComplete: item.status.indexOf('import') === 0 && !this.hasImportedItems(item),
          link: `https://leanlaw.oneschema.co/imports/${item.id}`
        }));
        this.$patch({
          imports,
          loading: false
        });
        return response.data;
      } catch (e) {
        this.loading = false;
        this.handleError(e);
      }
    },
    hasImportedItems(i) {
      return i.counts && (i.counts.primary || i.counts.secondary);
    },
    hasImportedClients(i) {
      return i.template === 'clientMatter' && i.counts && i.counts.primary;
    },
    async deleteImport(importId) {
      this.loading = true;
      await axios({
        method: 'DELETE',
        url: `/imports/${importId}`
      });
      this.listImports();
    },
    async syncImport() {
      try {
        const response = await axios({
          method: 'POST',
          url: `/imports/sync`
        });
        return response.data;
      } catch (e) {
        this.handleError(e);
      }
    },
    async completeImport(importId) {
      this.loading = true;
      try {
        const response = await axios({
          method: 'POST',
          url: `/imports/${importId}/import`
        });
        this.listImports();
        return response.data;
      } catch (e) {
        this.handleError(e);
        this.loading = false;
        return null;
      }
    },
    async getImporter() {
      if (_importer) return _importer;
      const response = await axios({
        url: '/imports/token'
      });
      this.credentials = {
        clientId: response.data.clientId,
        token: response.data.token
      };
      _importer = oneschemaImporter({
        clientId: this.credentials.clientId,
        userJwt: this.credentials.token,
        devMode: this.credentials.development
      });
      _importer.on('success', async data => {
        this.listImports();
      });
      _importer.on('launched', async data => {
        this.sessionToken = data.sessionToken;
      });
      _importer.on('error', error => {
        console.log(error);
        this.error = JSON.stringify(error);
      });
      return _importer;
    },
    async initiateSession(templateKey) {
      this.error = null;
      const importer = await this.getImporter();
      importer.launch({
        templateKey,
        // importConfig: { type: "webhook", key: 'import' },
        importConfig: {
          type: 'local',
          metadataOnly: true
        }
      });
    },
    async resumeSession() {
      const importer = await this.getImporter();
      importer.launch({
        sessionToken: this.sessionToken
      });
    }
  }
});